/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Attachment } from '../../models/attachment';
import { FilesUploadDto } from '../../models/files-upload-dto';

export interface UploadAttachments$Params {
  entityId: string;
  secondaryType?: string;
  entityClass: 'BulkPrintRequest' | 'FormQualityEntry' | 'FormRiskEntry' | 'FormSnapshotRequest' | 'FormCustom';
  body: FilesUploadDto;
}

export function uploadAttachments(
  http: HttpClient,
  rootUrl: string,
  params: UploadAttachments$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<Array<Attachment>>> {
  const rb = new RequestBuilder(rootUrl, uploadAttachments.PATH, 'post');
  if (params) {
    rb.path('entityId', params.entityId, {});
    rb.query('secondaryType', params.secondaryType, {});
    rb.path('entityClass', params.entityClass, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Attachment>>;
    })
  );
}

uploadAttachments.PATH = '/attachments/{entityClass}/{entityId}';
